// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n[data-v-1ed73f61] .filter-manager {\r\n  background-color: transparent !important;\n}\r\n", ""]);
// Exports
module.exports = exports;
